import { inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable } from "../../../../scene/viewable/Viewable";
import { VariableSaver } from "../../../../tools/variableSaver/VariableSaver";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../shared/async/PromiseCompletionSource";
import { CookiesPopupView } from "./view/CookiesPopupView";
import { IGuestModel } from "../../common/models/IGuestModel";
import { IAnalyticProviderWrapper } from "../../../../analytics/IAnalyticProviderWrapper";

@injectable()
export class CookiesPopupScene extends Viewable<void> {
    public constructor(
        variableSaver: VariableSaver,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IGuestModel") guestModel: IGuestModel,
        @inject("IAnalyticProviderWrapper") analyticsProvider: IAnalyticProviderWrapper
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new CookiesPopupView(pcs, variableSaver, canvasScaler, guestModel, analyticsProvider);
        pcs.result.then(() => {
            this.operationControls.complete();
        }, (reason: any) => {
            throw reason;
        });
    }
}